/* Note: During development to enable typescript for this file, uncomment this block and comment out the const window
///<reference lib="dom"/>

declare global {
    interface Window {
        ReactNativeWebView: any;
        svg: SVGSVGElement;
        origViewBox: { x: number, y: number, width: number, height: number };
        viewBox: { x: number, y: number, width: number, height: number };
        isMapMove: boolean;
        keepMapMovingTimer?: number;
        isMouseDown: boolean;
        keepZooming: boolean;
        keepZoomingTimer?: number;
        activeAreas: string[]
    }
}
*/

import { MAP_RUNTIME_SOURCE } from './mapRuntime.generated';

/**
 * Builds the <script> tag for the map page. The runtime itself lives in
 * mapRuntime.source.js and is embedded via the generated string constant, so it does
 * not depend on Function.prototype.toString() (which Hermes replaces with
 * "[bytecode]" in release builds).
 */
const getScriptTag = ({ activeAreas = [] }: { activeAreas?: string[] }) => {
  return `
        <script>
            window.activeAreas = [${activeAreas.map(activeArea => `'${activeArea}'`)}];
            ${MAP_RUNTIME_SOURCE}
            window.addEventListener('load', init);
            window.addEventListener('message', onMessage);
        </script>`;
};

export { getScriptTag };
